import { render } from "./ClubOfficials.vue?vue&type=template&id=07c2cf52&scoped=true"
import script from "./ClubOfficials.vue?vue&type=script&lang=js"
export * from "./ClubOfficials.vue?vue&type=script&lang=js"

import "./ClubOfficials.vue?vue&type=style&index=0&id=07c2cf52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c2cf52"]])

export default __exports__